import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { MaterialProperties } from '@steelbuy/ts-shared';
import { Card, Icon, IconIdentifier } from '@steelbuy/ui-primitive';
import { getQualityDisplayValue } from '@steelbuy/util';
import './RFQTeaser.scss';

type MaterialPropertiesWithQuality = MaterialProperties & { prime?: boolean; quality?: string };

const getAttributes = (
    material: MaterialPropertiesWithQuality,
    t: TFunction<'domainModel', undefined>,
    showQuality?: boolean
): { label: string; value: string }[] => {
    const labelAndValues = [];
    if (material.definition) {
        labelAndValues.push({
            label: t('material.definition.name'),
            value: t(`material.definition.value.${material.definition}`),
        });
    }
    if (material.plateType) {
        labelAndValues.push({
            label: t('material.plateType.name'),
            value: t(`material.plateType.value.${material.plateType}`),
        });
    }
    if (showQuality) {
        labelAndValues.push({
            label: t('material.quality.name'),
            value: getQualityDisplayValue(material.quality, material.prime ?? false, t),
        });
    }
    return labelAndValues;
};

export const RFQTeaser = ({
    material,
    showQuality,
}: {
    material: MaterialPropertiesWithQuality;
    showQuality?: boolean;
}) => {
    const { t } = useTranslation('domainModel');
    const attributes = getAttributes(material, t, showQuality) || {};
    const materialTranslation = material.materialType && t(`material.materialType.value.${material.materialType}`);
    const productTranslation = material.product && t(`material.product.value.${material.product}`);

    return (
        <div className="rfq-teaser">
            <Card isClickable={false}>
                <div className="rfq-teaser-header">
                    {material.product && (
                        <div className="rfq-teaser-header__icon">
                            <Icon name={IconIdentifier[material.product]} />
                        </div>
                    )}

                    <div className="rfq-teaser-header__product">
                        <span className="rfq-teaser-header__product__type">
                            {material.product ? `${productTranslation}, ` : ''}
                            {material.materialType ? `${materialTranslation}` : ''}
                        </span>
                    </div>
                </div>
                {attributes.map(({ label, value }) => (
                    <div className="rfq-teaser__attribute" key={`${label}-${value}`}>
                        <span className="rfq-teaser__attribute__label">{label}</span>
                        <span className="rfq-teaser__attribute__name">{value}</span>
                    </div>
                ))}
            </Card>
        </div>
    );
};
